export const GROUP_ROW_HEIGHT = 40;

/**
 * Rows a group shows before its "Show more". A host that pages its rows should fetch in this same
 * size (`TASKS_DASHBOARD_GANTT_PAGE_SIZE` does): every click then adds the same number of rows,
 * whether they were already loaded or had to be fetched.
 */
export const DEFAULT_TASK_LIMIT = 20;
